import * as React from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import styles from './business-share-icons.module.scss';
import IconFacebook from './social-and-share-icon/facebook-social';
import IconLinkedIn from './social-and-share-icon/linkedIn-social';
import IconShare from './social-and-share-icon/share';
import IconTwitter from './social-and-share-icon/twitter-social';

declare global {
    interface Window {
        clipboardData: any;
    }
}

if (typeof window !== 'undefined') {
    window.clipboardData = window.clipboardData || {};
}

interface Props {
    shareUrl?: string;
}
interface ButtonItem {
    type: string;
    urlShare: string;
    compShare: React.ReactElement<any>;
}
interface PopupCenter {
    url: string;
    title: string;
    popupWidth: number;
    popupHeight: number;
}
const copyToClipboard = (text: string): boolean => {
    if (typeof window !== 'undefined' && window?.clipboardData && window?.clipboardData.setData) {
        return window?.clipboardData.setData('Text', text);
    } else if (document.queryCommandSupported && document.queryCommandSupported('copy')) {
        var textarea = document.createElement('textarea');
        textarea.textContent = text;
        textarea.style.position = 'fixed';
        document.body.appendChild(textarea);
        textarea.select();
        try {
            return document.execCommand('copy');
        } catch (ex) {
            console.warn('Copy to clipboard failed.', ex);
        } finally {
            document.body.removeChild(textarea);
        }
    }

    return false;
};

const handlePopupCenter = ({ url, title, popupWidth, popupHeight }: PopupCenter) => {
    const dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : window.screenX;
    const dualScreenTop = window.screenTop !== undefined ? window.screenTop : window.screenY;

    const width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
    const height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;

    const systemZoom = width / window.screen.availWidth;
    const left = (width - popupWidth) / 2 / systemZoom + dualScreenLeft;
    const top = (height - popupHeight) / 2 / systemZoom + dualScreenTop;
    const newWindow = window.open(
        url,
        title,
        `
      scrollbars=yes,
      width=${popupWidth / systemZoom}, 
      height=${popupHeight / systemZoom}, 
      top=${top}, 
      left=${left}
      `
    );
    if (window?.focus as any) newWindow?.focus();
};

const getUrlShare = (type: string, urlShare: string): string => {
    switch (type) {
        case 'facebook':
            return `https://www.facebook.com/sharer.php?u=${urlShare}`;
        case 'linkedIn':
            return `https://www.linkedin.com/sharing/share-offsite/?url=${urlShare}`;
        case 'twitter':
            return `https://twitter.com/intent/tweet?url=${urlShare}`;
        case 'mail':
            return `mailto:?body=${urlShare}`;
        default:
            return urlShare;
    }
};
const getTooltipMessage = (type: string): string => {
    switch (type) {
        case 'facebook':
            return 'Share on Facebook';
        case 'linkedIn':
            return 'Share on LinkedIn';
        case 'twitter':
            return 'Share on Twitter';
        case 'mail':
            return 'Click to copy';
        default:
            return 'Click to copy';
    }
};
const socialAndShares = [
    { type: 'facebook', urlShare: '', compShare: <IconFacebook /> },
    { type: 'linkedIn', urlShare: '', compShare: <IconLinkedIn /> },
    { type: 'twitter', urlShare: '', compShare: <IconTwitter /> },
    { type: 'copy', urlShare: '', compShare: <IconShare /> },
];
const SocialAndShare: React.FC<Props> = (props) => {
    const [isCopied, setIsCopied] = React.useState(false);
    const { shareUrl = '' } = props;

    return (
        <div className={styles.businessSocialAndShareContainer}>
            {(socialAndShares || []).map((item: ButtonItem) => {
                const linkShare = getUrlShare(item.type, item.urlShare || shareUrl);
                if (item.type === 'copy') {
                    return (
                        <CopyToClipboard
                            key={item.type}
                            text={linkShare}
                            onCopy={() => {
                                setIsCopied(true);
                                setTimeout(() => {
                                    setIsCopied(false);
                                }, 3000);
                            }}
                        >
                            <div key={item.type} className={styles.businessSocialAndShareLink}>
                                {item.compShare}
                                <span className={styles.businessSocialAndShareTooltip}>{isCopied ? 'Copied' : getTooltipMessage(item.type)}</span>
                            </div>
                        </CopyToClipboard>
                    );
                }

                return (
                    <div
                        key={item.type}
                        className={styles.businessSocialAndShareLink}
                        onClick={() => {
                            item.type === 'copy'
                                ? copyToClipboard(linkShare)
                                : handlePopupCenter({ url: linkShare, title: getTooltipMessage(item.type), popupWidth: 400, popupHeight: 300 });
                        }}
                    >
                        {item.compShare}
                        <span className={styles.businessSocialAndShareTooltip}>{getTooltipMessage(item.type)}</span>
                    </div>
                );
            })}
        </div>
    );
};

export default SocialAndShare;
